import { motion, type Transition, type Variants } from 'motion/react';
import type { ReactNode } from 'react';

const variants: Variants = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0 },
};

const transition: Transition = { duration: 0.7, ease: [0.22, 1, 0.36, 1] };

type Props = {
  children: ReactNode;
  delay?: number;
  className?: string;
};

// Fades + lifts its children in once, the first time they scroll into view.
export default function Reveal({ children, delay = 0, className = '' }: Props) {
  return (
    <motion.div
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '0px 0px -8% 0px' }}
      transition={{ ...transition, delay: delay / 1000 }}
    >
      {children}
    </motion.div>
  );
}
